export enum CampaignStatus {
  ACTIVE = 'ACTIVE', // currently running campaign
  PAUSED = 'PAUSED', // paused by user (would be running)
  SCHEDULED = 'SCHEDULED', // scheduled to start in future
  EXPIRED = 'EXPIRED', // expired or ended
}

// TODO: verify options
export enum CampaignFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum CampaignRecipientStatus {
  ACTIVE = 'ACTIVE',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
  INVALID = 'INVALID', // contact info invalid
}
